import rp, { SqlEditorOptions } from "@reporting/rp-app-host";
import { Parameter } from "@reporting/rp-types/ext";
import { QuerySqlEditorAdapter } from "./querySqlEditorAdapter";

export class ParamSqlEditorAdapter extends QuerySqlEditorAdapter {

	constructor(
		private parameter: Parameter,
		private type: 'content'|'value'
	) { super({id_thread: 0}) }

	async getContent() : Promise<string> {
		const p = await rp.ms('extensions').get<Parameter>(`parameters/${this.parameter.idz}`);
		return this.type == 'content' ? p.content : p.default_value;
	}

	async save(sql: string) {
		// every save soft-deletes the current row and inserts a new one, so the idz changes
		const saved = await rp.ms('extensions').post<Parameter>(`parameters`, (this.type == 'content' ? {
			idz: this.parameter.idz,
			id_thread: this.parameter.id_thread,
			content: sql
		} : {
			idz: this.parameter.idz,
			id_thread: this.parameter.id_thread,
			default_value: sql
		}) as Parameter);

		if (saved?.idz) this.parameter.idz = saved.idz;
	}

	getOptions(): SqlEditorOptions {
		return this.createOptions({history: false});
	}

}
